<template>
  <div>
    <v-dialog v-model="dialog" width="390" transition="dialog-bottom-transition" persistent content-class="clock-result-dialog">
      <v-card class="clock-result-card" elevation="24">
        <div class="clock-result-accent" :class="resultClass"></div>
        <v-card-text class="clock-result-content">
          <div class="clock-result-icon" :class="resultClass">
            <v-icon>{{ resultIcon }}</v-icon>
          </div>
          <div class="clock-result-eyebrow">Time clock updated</div>
          <h1>{{ resultTitle }}</h1>
          <p>{{ resultMessage }}</p>

          <v-avatar class="clock-result-avatar" size="96">
              <img v-if="employeeImage &&
                this.setting &&
                this.setting.LocationIntegration &&
                this.setting.LocationIntegration.metadata &&
                this.setting.LocationIntegration.metadata
                  .storeTimeClockImageView
                " :src="employeeImage.dataUrl" class="image" alt="Employee photo" />

              <img v-else :src="getImage" class="image" alt="Employee photo" />
          </v-avatar>

          <h2 class="text-capitalize">{{ employee && employee.name }}</h2>
          <div class="clock-result-time">{{ time | moment("LT") }}</div>

          <v-btn class="clock-result-close" color="primary" @click="$emit('close')" rounded block large>Done
              <v-progress-circular :rotate="360" class="ml-1" :size="20" :value="value" color="white">
              </v-progress-circular>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserImg from "@/assets/images/user.jpeg";

export default {
  props: ["openSubmitDialog", "employee", "status", "employeeImage", "setting", "action"],
  name: "clock-InOut-message",
  data() {
    return {
      dialog: false,
      interval: {},
      value: 0,
      clockOut: false,
      time: new Date(),
      myStyle: {
        backgroundColor: this.status === "clockedIn" ? "#e8ada6" : "#aad3ac",
      },
    };
  },
  beforeDestroy() {
    this.value = 0
    clearInterval(this.interval);
  },
  watch: {
    openSubmitDialog(val) {
      if (val) {
        this.startCounting();
      } else {
        clearInterval(this.interval);
      }
      this.dialog = val
      this.time = new Date()
    },
  },
  computed: {
    resultTitle() {
      if (this.status === "clockedOut") return "Clocked in";
      if (this.status === "clockedIn") return this.action === "breakStart" ? "Break started" : "Clocked out";
      if (this.status === "breakStart") return "Break ended";
      if (this.status === "breakEnd") return "Welcome back";
      return "Success";
    },
    resultMessage() {
      return this.status === "clockedOut" ? "Your shift has started. Have a great day." : "Your time has been recorded successfully.";
    },
    resultClass() {
      return this.status === "clockedOut" || this.status === "breakStart" ? "is-in" : "is-out";
    },
    resultIcon() {
      return this.status === "clockedOut" || this.status === "breakStart" ? "mdi-check" : "mdi-logout";
    },
    getImage() {
      if (this.employee && this.employee.imageURL) {
        return this.employee.imageURL;
      } else return UserImg;
    },
  },
  methods: {
    startCounting() {
      // console.log("start ed");
      this.interval = setInterval(() => {
        if (this.value === 100) {
          clearInterval(this.interval);
          this.value = 0
          return this.$emit("closeSubmitDialog");
        }
        this.value += 10;
      }, 250);
    },
    close() {
      this.$emit("close");
      // this.$router.push({ name: "clockInOut" });
    },
  },
};
</script>

<style scoped>
.image {
  object-fit: cover !important;
}
.clock-result-card { background: #0d1b2d !important; border: 1px solid #26384e; border-radius: 24px !important; overflow: hidden; color: #e5edf8; }
.clock-result-accent { height: 5px; background: #34d399; }
.clock-result-accent.is-out { background: #fb7185; }
.clock-result-content { align-items: center; display: flex; flex-direction: column; padding: 28px !important; text-align: center; }
.clock-result-icon { align-items: center; background: rgba(52, 211, 153, 0.14); border: 1px solid rgba(52, 211, 153, 0.34); border-radius: 50%; display: flex; height: 58px; justify-content: center; margin-bottom: 14px; width: 58px; }
.clock-result-icon .v-icon { color: #34d399; font-size: 32px; }
.clock-result-icon.is-out { background: rgba(251, 113, 133, 0.12); border-color: rgba(251, 113, 133, 0.34); }
.clock-result-icon.is-out .v-icon { color: #fb7185; }
.clock-result-eyebrow { color: #93a4ba; font-size: 11px; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; }
.clock-result-content h1 { color: #e5edf8; font-size: 28px; margin: 3px 0 4px; }
.clock-result-content p { color: #93a4ba; font-size: 13px; margin: 0 0 18px; }
.clock-result-avatar { border: 2px solid #26384e; margin-bottom: 12px; }
.clock-result-content h2 { color: #e5edf8; font-size: 18px; margin: 0; }
.clock-result-time { color: #60a5fa; font-size: 24px; font-weight: 800; margin: 3px 0 20px; }
.clock-result-close { font-weight: 800; letter-spacing: 0; text-transform: none; }
@media (max-width: 420px) {
  .clock-result-content { padding: 22px !important; }
}
</style>
